package br.com.texeratx.boardgametimeapp.data.model.clan

import kotlinx.serialization.Serializable

@Serializable
data class ClanDTO(
    val id: Long,
    val name: String,
    val imageUrl: String? = null,
    val requireApproval: Boolean = false,
    val status: Int
)

@Serializable
data class UpdateClanRequest(
    val name: String,
    val imageUrl: String? = null,
    val requireApproval: Boolean? = null
)

@Serializable
data class CreateClanRequest(
    val name: String,
    val imageUrl: String? = null
)

@Serializable
data class UserClanMembershipDTO(
    val clanId: Long,
    val clanName: String,
    val clanImageUrl: String? = null,
    val role: String,
    val joinedAt: String? = null,
    val requireApproval: Boolean = false
)

@Serializable
data class ClanMemberDTO(
    val userId: Long,
    val email: String,
    val displayName: String,
    val imageUrl: String? = null,
    val role: String,
    val joinedAt: String
)

@Serializable
data class UpdateMemberRoleRequest(
    val role: String
)

@Serializable
data class ClanInviteDTO(
    val id: Long,
    val clanId: Long,
    val code: String,
    val createdByUserId: Long,
    val createdAt: String,
    val expiresAt: String? = null,
    val maxUses: Int? = null,
    val usesCount: Int = 0,
    val status: Int = 1
) {
    val revoked: Boolean get() = status == 0
    val uses: Int get() = usesCount
}

@Serializable
data class CreateInviteRequest(
    val expiresAt: String? = null,
    val maxUses: Int? = null
)

@Serializable
data class JoinClanRequestBody(
    val code: String
)

@Serializable
data class JoinClanResponse(
    val status: String,
    val clanId: Long? = null,
    val clanName: String? = null,
    val role: String? = null,
    val requestId: Long? = null
)

@Serializable
data class ClanJoinRequestDTO(
    val id: Long,
    val clanId: Long,
    val userId: Long,
    val userEmail: String,
    val userDisplayName: String,
    val userImageUrl: String? = null,
    val inviteCode: String? = null,
    val createdAt: String,
    val status: String
)
